<template>
  <div class="hora">
    <div
      class="show container"
      style="font-family: IRANSansX-Regular">
      <div class="row justify-content-md-center row-cols-1 mb-3">
        <div class="col-12 col-md-11 col-xl-7 mr-auto mx-auto order-1 p-0 p-md-2">
          <ChartInfoFree
            v-if="loadData['user']"
            :data="loadData"/>
        </div>

        <div
          id="share-box"
          class="col-12 col-md-11 col-xl-7 mr-auto mx-auto order-2 p-0 p-md-2 m-md-auto mt-3"
        >
          <ShareLinkFree
            v-if="loadData['user']"
            :data="loadData"/>
        </div>
        <!-- <div
          class="col-12 col-md-11 col-xl-7 mr-auto mx-auto mt-3 mt-md-0 order-3 p-0 p-md-2"
          v-if="loadData['user'] && loadData['is_prashna'] == '0'"
        >
          <div class="accordion" id="accordionPanelsSOAnalysis">
            <div class="accordion-item">
              <h2 class="accordion-header" id="panelsSO-headingOne">
                <button
                  class="accordion-button accordion-custom-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsSO-collapseOne"
                  aria-expanded="true"
                  aria-controls="panelsSO-collapseOne"
                >
                  تحلیل پایه‌ای چارت
                </button>
              </h2>
              <div
                id="panelsSO-collapseOne"
                class="accordion-collapse collapse show"
                aria-labelledby="panelsSO-headingOne"
              >
                <div class="accordion-body">
                  <ChartAnalysisFree
                    v-if="loadData['user'] && loadData['analysis']"
                    :data="loadData"
                  ></ChartAnalysisFree>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <!-- <div
        class="row justify-content-md-center mb-3"
        v-if="loadData['user'] && loadData['is_prashna'] == 0"
      >
        <div
          class="col-12 col-md-11 col-xl-6 mr-auto mx-auto mb-3 chart-form p-0 text-center"
          style="
            direction: rtl;
            text-align: center;
            color: rgb(0, 0, 0);
            font-size: 16px;
            border-radius: 8px;
            border: 1px solid rgb(204, 204, 204);
            box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 2px;
            background: rgb(255, 255, 255);
          "
        >
          <button
            class="btn bg-success p-3 text-white w-100 fw-bold"
            type="button"
            @click="goToReport"
          >
            خرید تفسیر چارت پریمیوم برای این چارت
          </button>
        </div>
      </div> -->

      <!-- <div
        class="col-12 col-md-10 col-lg-7 mr-auto mx-auto mb-3 mt-md-0 order-3 p-0 p-md-2"
      >
        <div
          v-if="loadData['user'] && loadData['analysis']"
          onclick="window.open('http://localhost:8083/%d9%82%d8%af%d9%85-%d8%a8%d8%b9%d8%af%db%8c/', '_blank');"
          class="col-12 col-md-10 col-lg-7 mr-auto mx-auto mt-2 mt-md-0 order-3 p-0 p-md-2"
          style="
            color: #000;
            cursor: pointer;
            background: #fffde7;
            borde-radius: 8px;
            box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 2px;
            border: 1px solid #f2f2f2;
            border-radius: 8px;
          "
        >
          <div class="row p-0 m-0 chart-cta">
            <div class="col-4">
              <div class="chart-eye-icon"></div>
            </div>
            <div
              class="col-8"
              style="
                text-align: center;
                line-height: 3rem;
                font-size: 18px;
                font-weight: bold;
                color: #000;
                text-shadow: 1px 1px #fff;
              "
            >
              قدم بعدی چیست؟
            </div>
          </div>
        </div>
      </div> -->

      <div
        class="row justify-content-md-center"
        style="direction: ltr">
        <div
          ref="chart_box"
          class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0">
          <div
            v-if="loadData['bhava'] && loadData['graha']"
            id="accordionExample3"
            :style="`width: ${main_box_width}px; box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16); border-radius: 7px;`"
            class="accordion mr-auto mx-auto"
          >
            <div class="accordion-item">
              <h2
                id="headingTwo3"
                class="accordion-header">
                <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo3"
                  aria-expanded="false"
                  aria-controls="collapseTwo3"
                >
                  D1 - Rashi Chart
                </button>
              </h2>
              <div
                id="collapseTwo3"
                class="accordion-collapse show"
                aria-labelledby="headingTwo3"
                data-bs-parent="#accordionExample3"
              >
                <div class="accordion-body p-0">
                  <keep-alive>
                    <Chart
                      v-if="loadData['bhava'] && loadData['graha']"
                      :varga_number="'D1'"
                      :varga_name="'Rasi'"
                      :bhavas="loadData['bhava']"
                      :grahas="loadData['graha']"
                      :show_degree="true"
                      :is_main_chart="true"
                      :box_width="main_box_width - 5"
                      class="mr-auto mx-auto"
                    />
                  </keep-alive>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="loadData['user']"
          class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0"
        >
          <div
            v-if="loadData['bhava'] && loadData['graha']"
            id="accordionExample4"
            :style="`width: ${box_width}px; box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16); border-radius: 7px;`"
            class="accordion mr-auto mx-auto"
          >
            <div class="accordion-item">
              <h2
                id="headingTwo4"
                class="accordion-header">
                <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo4"
                  aria-expanded="false"
                  aria-controls="collapseTwo4"
                  v-text="chart2Text"
                />
              </h2>
              <div
                id="collapseTwo4"
                class="accordion-collapse show"
                aria-labelledby="headingTwo4"
                data-bs-parent="#accordionExample4"
              >
                <div class="accordion-body p-0">
                  <keep-alive>
                    <Chart
                      v-if="loadData['varga']"
                      :varga_number="'D9'"
                      :varga_name="'Navamsa'"
                      :bhavas="loadData['varga'][this.chart2Varga]['bhava']"
                      :grahas="loadData['varga'][this.chart2Varga]['graha']"
                      :show_degree="false"
                      :is_main_chart="false"
                      :box_width="box_width - 5"
                      class="mr-auto mx-auto"
                    />
                  </keep-alive>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="loadData['user']"
        class="row justify-content-md-center"
        style="direction: ltr"
      >
        <div class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0">
          <div
            id="accordionPanelsStayOpenPlanetryPlanetry"
            :style="`width: ${main_box_width}px`"
            class="accordion mr-auto mx-auto"
            style="box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 2px; border-radius: 8px"
          >
            <div class="accordion-item">
              <h2
                id="panelsStayOpenPlanetry-headingOne"
                class="accordion-header">
                <button
                  class="accordion-button accordion-custom-butt on"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpenPlanetry-collapseOne"
                  aria-expanded="true"
                  aria-controls="panelsStayOpenPlanetry-collapseOne"
                >
                  جدول سیاره‌ای
                </button>
              </h2>
              <div
                id="panelsStayOpenPlanetry-collapseOne"
                class="accordion-collapse collapse show"
                aria-labelledby="panelsStayOpenPlanetry-headingOne"
              >
                <div
                  class="accordion-body p-1"
                  style="background-color: #f9f9f9; overflow-y: scroll"
                >
                  <PlanetryTableFree
                    :grahas="loadData['graha']"
                    :lagna="loadData['lagna']"
                    :box_width="main_box_width"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="loadData['is_prashna'] == 0"
          class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0"
        >
          <div
            id="accordionPanelsStayOpenDashaDasha"
            :style="`width: ${box_width}px`"
            class="accordion mr-auto mx-auto"
            style="box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 2px; border-radius: 8px"
          >
            <div class="accordion-item">
              <h2
                id="panelsStayOpenDasha-headingOne"
                class="accordion-header">
                <button
                  class="accordion-button accordion-custom-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpenDasha-collapseOne"
                  aria-expanded="true"
                  aria-controls="panelsStayOpenDasha-collapseOne"
                >
                  دوره‌های سیاره‌ای
                </button>
              </h2>
              <div
                id="panelsStayOpenDasha-collapseOne"
                class="accordion-collapse collapse show"
                aria-labelledby="panelsStayOpenDasha-headingOne"
              >
                <div
                  class="accordion-body p-1"
                  style="background-color: #f9f9f9">
                  <DashaTable
                    v-if="loadData['dasha']"
                    :birthdate="loadData['user']['datetime']"
                    :date_type="loadData['user']['date_type']"
                    :data="loadData['dasha']"
                    :box_width="box_width"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from '../components/Chart.vue'
import ChartInfoFree from '../components/ChartInfoFree.vue'
import ChartAnalysisFree from '../components/ChartAnalysisFree.vue'
import ShareLinkFree from '../components/ShareLinkFree.vue'
import PlanetryTableFree from '../components/PlanetryTableFree.vue'
import DashaTable from '../components/DashaTable.vue'
import HelperLib from '../components/helper'
import HoraLogo from '../components/HoraLogo.vue'
import NoteListPro from '../components/NoteListPro.vue'
import ApiService from '../service/api'
import Loading from '../components/Loading.vue'

export default {
  name: 'FreeAppView',
  components: {
    Chart,
    ChartInfoFree,
    ChartAnalysisFree,
    PlanetryTableFree,
    DashaTable,
    HelperLib,
    HoraLogo,
    ShareLinkFree,
    NoteListPro,
    ApiService,
    Loading
  },
  data () {
    return {
      isLoading: false,
      chart2Varga: 'D9',
      chart3Varga: 'D30',
      chart2Text: 'D9 - Navamsa Chart',
      chart3Text: 'D30 - Trimshamsha',
      link_clicked: false,
      loadData: [],
      requestData: '',
      box_width: null,
      main_box_width: null,
      pages: {
        is_calculate: true,
        is_charts: false,
        is_notes: false
      }
    }
  },
  watch: {
    loadData: function (data) {
      this.loadData = data
    }
  },
  mounted: function () {
    this.adjustBoxesWidth()
  },
  created () {
    let id = document.getElementsByName('share_id')[0]['value']

    this.isLoading = true
    ApiService.getSharedChart(id).then((response) => {
      this.isLoading = false
      this.loadData = response['data']
    })
  },
  methods: {
    goToReport () {
      this.requestData = {
        id: this.loadData['link']
      }

      this.isLoading = true
      ApiService.createReportOrder(this.requestData).then((response) => {
        // console.log(response);
        this.isLoading = false
        window.location.replace(response['data']['checkout_url'])
      })
    },

    adjustBoxesWidth () {
      if (screen.width > 960) {
        // DESKTOP
        this.box_width = (this.$refs.chart_box.clientWidth * 92) / 100
        this.main_box_width = (this.$refs.chart_box.clientWidth * 97) / 100
      } else {
        this.box_width = (this.$refs.chart_box.clientWidth * 100) / 100
        this.main_box_width = this.box_width
      }
    },
    isMobile () {
      return HelperLib.isMobile()
    },
    showMobileViewChartHeader (width) {
      return `
      font-size: 12px;
      border-radius: 8px;
      width: ${width}px;
      line-height: 10px;
      color: #000;`
    },
    formatLocation (user) {
      let lonDir = user['longitude'] < 0 ? 'W' : 'E'
      let latDir = user['latitude'] < 0 ? 'S' : 'N'
      let out =
        user['latitude_dms']['deg'] +
        ' ' +
        latDir +
        ' ' +
        user['latitude_dms']['min'] +
        ' - '
      out +=
        user['longitude_dms']['deg'] + ' ' + lonDir + ' ' + user['longitude_dms']['min']
      return out
    },
    formatLagnaText (rashi) {
      return HelperLib.rashiToPersianText(rashi)
    },
    getSignLink (data) {
      var lagna = HelperLib.rashiToPersianText(data['lagna']['Lg']['rashi'])
      return `${lagna[1]}`
    },
    updateLoadedData (data) {
      this.loadData = data
      // this.$chartNoteListRef.getList();
    },
    updateShowAnalysisOption (data) {
      this.show_analysis = data
    }
  }
}
</script>

<style scoped>
.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
.custom-accordion-header {
  background-color: #f2f2f2;
  color: #333;
  border: 1px solid #ccc;
}

.custom-accordion-header:hover {
  background-color: #e6e6e6;
}

.custom-accordion-header.active {
  background-color: #ddd;
}
.accordion-button-custom:not(.collapsed) {
  color: #000000;
  font-weight: bold;
  background-color: #fff;
  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);
}

* {
  padding: 0px;
  margin: 0px;
}
.now-analysis {
  direction: rtl;
  text-align: right;
  background-color: rgba(255, 253, 231, 0.5);
  border-radius: 0.25rem;
  font-size: 16px;
  color: black;
  border: 1px solid rgb(242, 242, 242);
}
.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
</style>
